import React from 'react'

import Canvas from '@/backgrounds/canvas.js'

const ColorSetOne = {
  colorOneR: 208,
  colorOneG: 204,
  colorOneB: 249,
  colorOneA: 1,
  colorTwoR: 145,
  colorTwoG: 172,
  colorTwoB: 245,
  colorTwoA: 1,
  colorThreeR: 255,
  colorThreeG: 226,
  colorThreeB: 204,
  colorThreeA: 0.1
}

const ColorSetTwo = {
  colorOneR: 255,
  colorOneG: 226,
  colorOneB: 204,
  colorOneA: 1,
  colorTwoR: 194,
  colorTwoG: 218,
  colorTwoB: 255,
  colorTwoA: 1,
  colorThreeR: 255,
  colorThreeG: 226,
  colorThreeB: 204,
  colorThreeA: 0.1
}

const ColorSetThree = {
  colorOneR: 208,
  colorOneG: 206,
  colorOneB: 249,
  colorOneA: 1,
  colorTwoR: 255,
  colorTwoG: 226,
  colorTwoB: 204,
  colorTwoA: 1,
  colorThreeR: 208,
  colorThreeG: 206,
  colorThreeB: 249,
  colorThreeA: 0.1
}

const ColorSetFour = {
  colorTwoR: 194,
  colorTwoG: 218,
  colorTwoB: 255,
  colorOneA: 1,
  colorOneR: 145,
  colorOneG: 172,
  colorOneB: 244,
  colorTwoA: 1,
  colorThreeR: 255,
  colorThreeG: 226,
  colorThreeB: 204,
  colorThreeA: 0.1
}

const ColorPurple = {
  colorTwoR: 208,
  colorTwoG: 206,
  colorTwoB: 249,
  colorOneA: 1,
  colorOneR: 208,
  colorOneG: 206,
  colorOneB: 249,
  colorTwoA: 1,
  colorThreeR: 208,
  colorThreeG: 206,
  colorThreeB: 249,
  colorThreeA: 1
}

const ColorBlue = {
  colorTwoR: 194,
  colorTwoG: 218,
  colorTwoB: 255,
  colorOneA: 1,
  colorOneR: 194,
  colorOneG: 218,
  colorOneB: 255,
  colorTwoA: 1,
  colorThreeR: 194,
  colorThreeG: 218,
  colorThreeB: 255,
  colorThreeA: 1
}

const ColorOrange = {
  colorTwoR: 255,
  colorTwoG: 226,
  colorTwoB: 204,
  colorOneA: 1,
  colorOneR: 255,
  colorOneG: 226,
  colorOneB: 204,
  colorTwoA: 1,
  colorThreeR: 255,
  colorThreeG: 226,
  colorThreeB: 204,
  colorThreeA: 1
}


class CanvasWrapper extends React.Component {
  constructor() {
    super();
    this.state = {
      fillState: 0,
      stop: true,
      ...ColorSetOne
    };
    this.updateGradient = this.updateGradient.bind(this);
  }
  componentDidMount() {
    this.rAf = requestAnimationFrame(this.updateGradient);
  }
  componentWillUnmount() {
    cancelAnimationFrame(this.rAF);
  }
  componentWillReceiveProps (props) {
    this.setState({
      background: props.background
    })
  }
  updateBackground (currentBackground, newBackground) {
    this.setState((prevState) => ({
      colorTwoR: prevState.colorTwoR < newBackground.colorTwoR ? prevState.colorTwoR + 1 : prevState.colorTwoR - 1,
      colorTwoG: prevState.colorTwoG < newBackground.colorTwoG ? prevState.colorTwoG + 1 : prevState.colorTwoG - 1,
      colorTwoA: prevState.colorTwoA < newBackground.colorTwoA ? prevState.colorTwoA + 1 : prevState.colorTwoA - 1,
      colorTwoB: prevState.colorTwoB < newBackground.colorTwoB ? prevState.colorTwoB + 1 : prevState.colorTwoB - 1,
      colorThreeR: prevState.colorThreeR < newBackground.colorThreeR ? prevState.colorThreeR + 1 : prevState.colorThreeR - 1,
      colorThreeG: prevState.colorThreeG < newBackground.colorThreeG ? prevState.colorThreeG + 1 : prevState.colorThreeG - 1,
      colorThreeA: prevState.colorThreeA < newBackground.colorThreeA ? prevState.colorThreeA + 1 : prevState.colorThreeA - 1,
      colorThreeB: prevState.colorThreeB < newBackground.colorThreeB ? prevState.colorThreeB + 1 : prevState.colorThreeB - 1,
      colorOneR: prevState.colorOneR < newBackground.colorOneR ? prevState.colorOneR + 1 : prevState.colorOneR - 1,
      colorOneG: prevState.colorOneG < newBackground.colorOneG ? prevState.colorOneG + 1 : prevState.colorOneG - 1,
      colorOneA: prevState.colorOneA < newBackground.colorOneA ? prevState.colorOneA + 1 : prevState.colorOneA - 1,
      colorOneB: prevState.colorOneB < newBackground.colorOneB ? prevState.colorOneB + 1 : prevState.colorOneB - 1
    }))

  }
  updateGradient() {
    switch(this.props.background) {
      case 'two':
        this.updateBackground(this.state.color, ColorSetTwo)
        break
      case 'three':
        this.updateBackground(this.state.color, ColorSetThree)
        break
      case 'four':
        this.updateBackground(this.state.color, ColorSetFour)
        break
      case 'purple':
        this.updateBackground(this.state.color, ColorPurple)
        break
      case 'blue':
        this.updateBackground(this.state.color, ColorBlue)
        break
      case 'orange':
        this.updateBackground(this.state.color, ColorOrange)
        break
      default:
        this.updateBackground(this.state.color, ColorSetOne)

    }

    this.rAF = requestAnimationFrame(this.updateGradient);
  }
  render() {
    return (
      <div className='site__canvas abs x y top left' onClick={() => this.switchColorRange()}>
        <Canvas {...this.state} />
      </div>
    );
  }
}

export default CanvasWrapper